"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSamePresentation = void 0;
var react_1 = __importStar(require("react"));
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var q_play_components_1 = require("@nordicscreen/q-play-components");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var Players_module_css_1 = __importDefault(require("./Players.module.css"));
var ThumbnailState;
(function (ThumbnailState) {
    ThumbnailState["LOADING"] = "LOADING";
    ThumbnailState["LOADED"] = "LOADED";
    ThumbnailState["REJECTED"] = "REJECTED";
})(ThumbnailState || (ThumbnailState = {}));
var isSamePresentation = function (presentationA, presentationB) {
    return presentationA.presentation_version_id === presentationB.presentation_version_id;
};
exports.isSamePresentation = isSamePresentation;
var Card = function (_a) {
    var presentation = _a.presentation, selectedPresentations = _a.selectedPresentations;
    var _b = (0, react_1.useState)(ThumbnailState.LOADING), thumbnailState = _b[0], setThumbnailState = _b[1];
    var thumbnailLoadingErrorHandler = function () {
        setThumbnailState(ThumbnailState.REJECTED);
    };
    var thumbnailLoadedHandler = function () {
        setThumbnailState(ThumbnailState.LOADED);
    };
    var isSelectedPresentation = function () {
        return selectedPresentations.some(function (p) { return (0, exports.isSamePresentation)(p, presentation); });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { "data-cy": "presentationCard" },
            thumbnailState === ThumbnailState.LOADING && (react_1.default.createElement("div", { className: "".concat(isSelectedPresentation() ? Players_module_css_1.default.selected_presentation : Players_module_css_1.default.presentation, " d-flex align-items-center justify-content-center"), style: { width: "150px", height: "70px" } },
                react_1.default.createElement(q_play_components_1.Spinner, null))),
            thumbnailState !== ThumbnailState.REJECTED && (react_1.default.createElement("div", { className: "d-flex flex-column justify-content-center align-items-center", style: { width: "150px", height: "70px" } },
                react_1.default.createElement("img", { style: { display: thumbnailState === ThumbnailState.LOADING ? "none" : "initial", maxHeight: "70px", maxWidth: "150px" }, className: "".concat(isSelectedPresentation() ? Players_module_css_1.default.selected_presentation : Players_module_css_1.default.presentation), src: presentation.thumbnail_url, onError: thumbnailLoadingErrorHandler, onLoad: thumbnailLoadedHandler }),
                react_1.default.createElement("div", { className: "d-flex justify-content-center" },
                    react_1.default.createElement("p", { className: Players_module_css_1.default.presentation_title }, presentation.title)))),
            thumbnailState === ThumbnailState.REJECTED && (react_1.default.createElement("div", { className: "d-flex flex-column justify-content-center align-items-center", style: { width: "150px" } },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { className: "".concat(isSelectedPresentation() ? Players_module_css_1.default.selected_presentation : Players_module_css_1.default.presentation), icon: pro_solid_svg_icons_1.faImageLandscape, color: "var(--lightgray-color)", size: "2x", width: "120.97px", style: { height: "70px" } }),
                react_1.default.createElement("div", { className: "d-flex justify-content-center" },
                    react_1.default.createElement("p", { className: Players_module_css_1.default.presentation_title }, presentation.title)))))));
};
exports.default = Card;
